import PrismicPage from "~/views/PrismicPage";

function Page(props) {
  return <PrismicPage {...props} />;
}

Page.getInitialProps = async (ctx) => {
  ctx.query.pageUID = ctx.query.prismicUid;
  return PrismicPage.getInitialProps(ctx);
};

export default Page;
